export enum REQUESTS_PATH {
    GET_NOTIFICATIONS = '/Notifications/My'
}
